<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{form.main.ec_code}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更类型</label>
            <span class="weui-form-preview__value">{{form.main.ec_type}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更原因</label>
            <span class="weui-form-preview__value">{{form.main.ec_reason}}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div    class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items1"
          :key="item.id">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">BOM编号</label>
            <span class="weui-form-preview__value">{{item.bo_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">成品名称</label>
            <span class="weui-form-preview__value">{{item.bo_mothername}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">成品编号</label>
            <span class="weui-form-preview__value">{{item.bo_mothercode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">品牌</label>
            <span class="weui-form-preview__value">{{item.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{item.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{item.pr_spec}}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items2"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.ed_bddetno }}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">操作类型</label>
            <span class="weui-form-preview__value">{{item.ed_type}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">BOM编号</label>
            <span class="weui-form-preview__value">{{item.ed_bocode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原工序</label>
            <span class="weui-form-preview__value">{{item.ed_old_process}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新工序</label>
            <span class="weui-form-preview__value">{{item.ed_new_process}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原物料编号</label>
            <span class="weui-form-preview__value">{{item.ed_soncode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新物料编号</label>
            <span class="weui-form-preview__value">{{item.ed_newsoncode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原物料名称</label>
            <span class="weui-form-preview__value">{{item.ed_son_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新物料名称</label>
            <span class="weui-form-preview__value">{{item.ed_new_son_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原单位</label>
            <span class="weui-form-preview__value">{{item.ed_old_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新单位</label>
            <span class="weui-form-preview__value">{{item.ed_new_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原标准用量</label>
            <span class="weui-form-preview__value">{{item.ed_oldbaseqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新标准用量</label>
            <span class="weui-form-preview__value">{{item.ed_newbaseqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原执行方式</label>
            <span class="weui-form-preview__value">{{item.ed_old_replace_status}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新执行方式</label>
            <span class="weui-form-preview__value">{{item.ed_new_replace_status}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原切换时间</label>
            <span class="weui-form-preview__value">{{item.ed_old_replace_time}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新切换时间</label>
            <span class="weui-form-preview__value">{{item.ed_new_replace_time}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原明细损耗(%)</label>
            <span class="weui-form-preview__value">{{item.ed_oldlossrate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新明细损耗(%)</label>
            <span class="weui-form-preview__value">{{item.ed_newlossrate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原替代物料</label>
            <span class="weui-form-preview__value">{{item.ed_old_replace_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新替代物料</label>
            <span class="weui-form-preview__value">{{item.ed_new_replace_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原替代物料编号</label>
            <span class="weui-form-preview__value">{{item.ed_old_replace_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新替代物料编号</label>
            <span class="weui-form-preview__value">{{item.ed_new_replace_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原位号</label>
            <span class="weui-form-preview__value">{{item.ed_oldlocation}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新位号</label>
            <span class="weui-form-preview__value">{{item.ed_newlocation}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原备注</label>
            <span class="weui-form-preview__value">{{item.ed_oldremark}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">新备注</label>
            <span class="weui-form-preview__value">{{item.ed_newremark}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更记录</label>
            <span class="weui-form-preview__value">{{item.ed_history}}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更人</label>
            <span class="weui-form-preview__value">{{form.main.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更日期</label>
            <span class="weui-form-preview__value">{{form.main.createTime}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{form.main.ed_auditman}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核日期</label>
            <span class="weui-form-preview__value">{{form.main.ed_auditdate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/make/ecndetail"
    };
  }
};
</script>